import React from 'react';
import { Card, CardContent } from './ui/card';
import { Target, Users, TrendingUp, Heart } from 'lucide-react';

export const About = () => {
  const features = [
    {
      icon: Target,
      title: "Praxisorientiert",
      description: "Über 25 Jahre unternehmerische Erfahrung fließen in jeden Kurs ein. Du bekommst keine Theorie, sondern bewährte Systeme."
    },
    {
      icon: Users,
      title: "Community",
      description: "Lerne Menschen kennen, die auf einem ähnlichen Weg sind. Gemeinsam wachsen und Netzwerke aufbauen."
    },
    {
      icon: TrendingUp,
      title: "Nachhaltige Transformation",
      description: "Unsere Seminare verändern nicht nur Dein Wissen, sondern Deinen gesamten Fokus und Deine finanzielle Zukunft."
    },
    {
      icon: Heart,
      title: "Mit Herz & System",
      description: "Die Kombination aus praktischen Systemen und persönlicher Entwicklung macht den Unterschied."
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          {/* Left Content */}
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold mb-6">
              <span className="text-gray-900">Warum </span>
              <span className="bg-gradient-to-r from-[#D4AF37] to-[#FFD700] bg-clip-text text-transparent">
                GeldGymnasium?
              </span>
            </h2>
            <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
              <p>
                Finanzielle Bildung wurde im Lehrplan der meisten Schulen leider irgendwie „vergessen". 
                Daher ist es von enormer Bedeutung für ein gutes Leben, Dich selbst zu bilden und diese 
                Kompetenz als Erwachsener zu entwickeln.
              </p>
              <p>
                Im Grundlagenseminar des Geldgymnasiums bekommst Du einen neuen Blick auf Deine aktuelle 
                finanzielle Situation, Du bekommst praktische Systeme an die Hand, um diese zu optimieren 
                und Du schaust Dir Deine Glaubenssätze an. Ganz nebenbei erfährst Du neue Wege, mit Deinem 
                Geld umzugehen und lernst Menschen kennen, die auf einem ähnlichen Weg wie Du sind.
              </p>
            </div>

            {/* Buffet Info */}
            <div className="mt-8 bg-gradient-to-r from-[#D4AF37]/10 to-[#FFD700]/10 border-l-4 border-[#D4AF37] p-6 rounded-r-lg">
              <h3 className="font-bold text-[#B8960C] mb-2 text-lg">Unser Community-Konzept</h3>
              <p className="text-gray-700">
                Für Deinen selbstgemachten Beitrag zum Buffet werden Dir 200 € auf den Seminarpreis 
                gutgeschrieben. Die Menge sollte für 1 bis 2 Personen reichen.
              </p>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBlZHVjYXRpb258ZW58MHx8fHwxNzYwNTMzNDcxfDA&ixlib=rb-4.1.0&q=85"
                alt="Finanzielle Planung"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card key={index} className="border-2 border-[#D4AF37]/20 hover:border-[#D4AF37] transition-all duration-300 hover:shadow-xl">
              <CardContent className="pt-6">
                <div className="w-12 h-12 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-lg flex items-center justify-center mb-4 shadow-lg">
                  <feature.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-bold text-xl mb-2 text-gray-900">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
